/*
  Offer form: main fields first, the rest folded. Merged FIRST into
  TRANSLATION_MAPS in ./index.js, so existing translations still win.
  Keys are the English source.
*/

const ru = {
  "Description, countries, daily cap and fallback offer.": "Описание, страны, дневной лимит и запасной оффер.",
};

const es = {
  "Description, countries, daily cap and fallback offer.": "Descripción, países, límite diario y oferta de respaldo.",
};

const pt = {
  "Description, countries, daily cap and fallback offer.": "Descrição, países, limite diário e oferta de reserva.",
};

const de = {
  "Description, countries, daily cap and fallback offer.": "Beschreibung, Länder, Tageslimit und Fallback-Offer.",
};

const fr = {
  "Description, countries, daily cap and fallback offer.": "Description, pays, plafond quotidien et offre de secours.",
};

const it = {
  "Description, countries, daily cap and fallback offer.": "Descrizione, paesi, limite giornaliero e offerta di riserva.",
};

const pl = {
  "Description, countries, daily cap and fallback offer.": "Opis, kraje, dzienny limit i oferta zapasowa.",
};

const tr = {
  "Description, countries, daily cap and fallback offer.": "Açıklama, ülkeler, günlük limit ve yedek teklif.",
};

const uk = {
  "Description, countries, daily cap and fallback offer.": "Опис, країни, денний ліміт і запасний офер.",
};

const OFFER_FORM = { ru, es, pt, de, fr, it, pl, tr, uk };
export default OFFER_FORM;
